module.exports = __webpack_public_path__ + "static/media/icon-menu-miscertificaciones.5f4b8f15.svg";